/* eslint-disable max-lines, max-lines-per-function */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import TabItems from '../tabItems/tabItems';
import TabUrl from '../tabUrl/tabUrl';
import styles from './tabModuleDesktop.module.scss';
import 'swiper/css'; // Swiper plugin predefined styles

function TabModuleDesktop({ items = [] }) {
  const [swiper, setSwiper] = useState(null);
  const [swiperIndex, setSwiperIndex] = useState(0);
  const swiperConfig = {
    slidesPerView: 1,
    speed: 1500,
    autoHeight: true,
    noSwiping: true,
    noSwipingClass: 'swiper-slide',
  };

  const slideTo = (index) => {
    if (swiper) {
      swiper.slideTo(index);
      setSwiperIndex(swiper.activeIndex);
    }
  };

  return (
    <>
      <div className={styles.tabsTabList}>
        {items?.map((item, index) => {
          return (
            <TabUrl
              index={index}
              swiperIndex={swiperIndex}
              title={item.title}
              key={item.title.toString()}
              slideTo={slideTo}
            />
          );
        })}
      </div>
      <Swiper
        {...swiperConfig}
        onSwiper={(swipe) => {
          setSwiper(swipe);
        }}
        className={styles.tabsContent}
      >
        {items?.map((item) => {
          return (
            <SwiperSlide
              key={item.tokenKey.toString()}
              className={styles.swiperSlideItem}
            >
              <TabItems {...item} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
}

TabModuleDesktop.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.any,
    })
  ),
};

export default TabModuleDesktop;
